import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-links">
          <ul>
            <li><a href="/terms" className="footer-link">Términos y Condiciones</a></li>
            <li><a href="/privacy" className="footer-link">Política de Privacidad</a></li>
            <li><a href="/cookies" className="footer-link">Política de Cookies</a></li>
          </ul>
        </div>
        <div className="footer-rights">
          <p>&copy; {new Date().getFullYear()} <a className="footer-link">Closer Academy</a>. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
